// extracted by mini-css-extract-plugin
export default {"stack":"TJ_4lw","space-small":"kUGKw5","spaceSmall":"kUGKw5","space-medium":"x5k631","spaceMedium":"x5k631","space-large":"ryLoHz","spaceLarge":"ryLoHz","column":"RDCBxT"};